import { render } from "./view_recent_uploads.html?vue&type=template&id=4f4b06ff&external"
import script from "./view_recent_uploads.js?vue&type=script&lang=js&external"
export * from "./view_recent_uploads.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__